import { AxiosError } from 'axios'

// Shared error-to-message helper. The auth/account pages all turn an unknown
// thrown value into a user-facing MX Spanish string the same way: prefer the
// API's `error.message`, fall back to a native Error message, then a generic
// line. Kept in one place so the three call sites can't drift.

interface ApiErrorBody {
  error: { code: string; message: string }
}

/** Maps an unknown thrown value to a user-facing MX Spanish message. */
export function describeError(err: unknown): string {
  if (err instanceof AxiosError && err.response?.data !== undefined) {
    return (err.response.data as ApiErrorBody).error.message
  }
  if (err instanceof Error) return err.message
  return 'Error desconocido. Inténtalo de nuevo.'
}
